import { render } from "./team-detail.vue?vue&type=template&id=714ae254&scoped=true"
import script from "./team-detail.vue?vue&type=script&lang=js"
export * from "./team-detail.vue?vue&type=script&lang=js"

import "./team-detail.vue?vue&type=style&index=0&id=714ae254&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/d72e10b2-82a4-4871-b4ef-3f0bf96be7c1/workspace/site-h5_3HZM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714ae254"]])

export default __exports__